import { useEffect } from 'react'

import { useCloseTraceLogOnIneligibleIncident } from '../../shared/hooks/useCloseTraceLogOnIneligibleIncident'
import { FeatureFlag, useFeatureFlag } from '@/hooks/useFeatureFlags'
import { useLightMode } from '@/hooks/useLightMode'
import { useWindowSize } from '@react-hook/window-size'
import { useDispatch, useSelector } from 'react-redux'

import { tokenVar } from '@hivewatch/dark'

import {
  closeTraceLogDrawer,
  selectIncidentTraceLogDrawerState,
} from '@/redux/ui/uiSlice'

import {
  INCIDENT_DRAWER_WIDTH,
  IncidentDrawerContainer,
} from '../../components/IncidentDrawerContainer'
import { EventFiltersI } from '../../shared/types/traceLogTypes'
import { TraceLogContent } from './TraceLogContent'

export const TRACELOG_DRAWER_WIDTH = 445
export const DRAWER_BREAKPOINT = INCIDENT_DRAWER_WIDTH + TRACELOG_DRAWER_WIDTH

export const TraceLogDrawer = ({ incident }: EventFiltersI) => {
  const isOpen = useSelector(selectIncidentTraceLogDrawerState)?.isOpen
  const dispatch = useDispatch()
  const [width] = useWindowSize()
  const isRebrand = useFeatureFlag(FeatureFlag.incidentDrawerRebrand)
  const mode = useLightMode()
  const isDark = mode === 'dark'
  // tokenVar resolves the dark-package semantic to its CSS var + fallback —
  // this container renders outside the DarkProvider, so a raw token name
  // would not resolve here.
  const drawerBg = isRebrand && isDark ? tokenVar('colors.bg.card') : 'white'

  useEffect(() => {
    if (width < DRAWER_BREAKPOINT) {
      dispatch(closeTraceLogDrawer())
    }
  }, [width])

  useCloseTraceLogOnIneligibleIncident({ incident })

  return (
    isOpen && (
      <IncidentDrawerContainer
        bgColor={drawerBg}
        borderColor={
          isRebrand
            ? isDark
              ? tokenVar('colors.border.subtle')
              : tokenVar('colors.light.border.subtle')
            : undefined
        }
        dataTestid='TraceLogDrawer:wrapper'
        width={TRACELOG_DRAWER_WIDTH}
      >
        <TraceLogContent incident={incident} />
      </IncidentDrawerContainer>
    )
  )
}
